// extracted by mini-css-extract-plugin
export default {"Vcard":"VirtualAccount_Vcard__SSkUq","VAcctTxt":"VirtualAccount_VAcctTxt__nR+H7","VFundTxt":"VirtualAccount_VFundTxt__6xsH6","VBank":"VirtualAccount_VBank__QkZzV"};